import React from 'react'
import { Wrapper } from './styles'

export default function Element({ message }) {
  return <Wrapper>{message ? message : 'Nenhum registrado encontrado'}</Wrapper>
}
